import { useInfrastructureContext } from '@/presentation/context/infrastructure';

export default function useInfrastructure() {
  return useInfrastructureContext();
}
